<template>
  <sui-segment raised>
    <sui-message align="center">
      <h3>{{ $t('strAbortSuccess') }}</h3>
      <p>{{ $t('strBackToShop') }}</p>
      <sui-button @click="clickBack" color="red" fluid>{{ $t('btnBackToShop') }}</sui-button>
    </sui-message>
  </sui-segment>
</template>

<script>
  export default {
    name: 'Abort',
    methods: {
      clickBack() {
        this.$router.push('/')
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
